import apiClient from './apiClient';
import {
  CREATE_DRINK_ITEM,
  DELETE_DRINK_ITEM,
  EDIT_DRINK_ITEM,
  GET_DRINK_ITEMS,
  HIDE_SHOW_DRINK_ITEM
} from '../constants/UriConstants';
import {
  CreateMenuItemInterface,
  CreateMenuItemResponse,
  DetailedMenuItemInterface,
  EditMenuItemResponse
} from '../types/MenuItemInterface';
import { LocationScope } from '../types/MenuInterface';
import { PairingInterface } from '../types/PairingInterface';
import { buildLocationScopeBody, restaurantHeaders } from '../utils/locationScope';

export const createDrinkItem = (
  drinkItem: CreateMenuItemInterface,
  locationScope: LocationScope = 'single',
  restaurantIDs: number[] = []
): Promise<CreateMenuItemResponse> =>
  apiClient
    .post(CREATE_DRINK_ITEM, { ...drinkItem, ...buildLocationScopeBody(locationScope, restaurantIDs) })
    .then((response) => response.data);

// restaurantID targets a copy at another location; defaults to the current location
export const deleteDrinkItem = async (drinkItemID: number, restaurantID?: number) => {
  await apiClient.delete(DELETE_DRINK_ITEM + drinkItemID, restaurantHeaders(restaurantID));
};

// resolves with the edited copies for a multi-location edit, and with undefined for this location only
export const editDrinkItem = async (
  drinkItem: DetailedMenuItemInterface,
  menuSectionID: number,
  locationScope: LocationScope = 'single',
  restaurantIDs: number[] = []
): Promise<EditMenuItemResponse | undefined> => {
  const response = await apiClient.put(EDIT_DRINK_ITEM, {
    ...drinkItem,
    menuSectionID,
    ...buildLocationScopeBody(locationScope, restaurantIDs)
  });
  return locationScope === 'single' ? undefined : response.data;
};

export const getDrinkItems = (): Promise<PairingInterface[]> =>
  apiClient.get(GET_DRINK_ITEMS).then((response) => response.data);

export const showDrinkItem = async (drinkItemID: number) => {
  await apiClient.put(HIDE_SHOW_DRINK_ITEM, { menuItemID: drinkItemID, hide: false });
};

export const hideDrinkItem = async (drinkItemID: number) => {
  await apiClient.put(HIDE_SHOW_DRINK_ITEM, { menuItemID: drinkItemID, hide: true });
};
